import { InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { formatIBAN, replaceSpaces } from '../../special/formatIban';

const TypeIban = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
}) => {
  const [value, setValue] = useState(dataCollection[field.key] || '');

  useEffect(() => {
    if (dataCollection[field.key])
      setValue(formatIBAN(dataCollection[field.key]));
  }, []);

  function handleTextChange(value) {
    const upperCased = value.target.value.toUpperCase();
    updateValidationOnChange([field.key], replaceSpaces(upperCased, ''));
    setValue(formatIBAN(upperCased));
  }

  const showError = Boolean(value && errors[field.key]);

  return (
    <TextField
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
      label={field.label}
      value={value}
      onChange={handleTextChange}
      error={showError}
      helperText={showError ? errors[field.key] : undefined}
      multiline={field.multiline ? true : false}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{field.unit}</InputAdornment>
        ),
      }}
    />
  );
};

export default TypeIban;
